let deferredPrompt = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event("a2g-installable"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
  });
}

export function hasInstallPrompt() {
  return !!deferredPrompt;
}

export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return outcome; // "accepted" | "dismissed"
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function getPlatform() {
  if (typeof window === "undefined") return "other";
  const ua = window.navigator.userAgent || "";
  if (/iPad|iPhone|iPod/.test(ua) || (ua.includes("Mac") && "ontouchend" in document)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "other";
}

// On iOS, PWA install works only in Safari (not Chrome/Firefox iOS or in-app browsers).
export function isSafari() {
  if (typeof window === "undefined") return true;
  const ua = window.navigator.userAgent || "";
  const inApp = /(FBAN|FBAV|Instagram|Line|Twitter|LinkedIn|Snapchat|Pinterest|GSA|WhatsApp|TikTok)/i.test(ua);
  const otherIosBrowser = /(CriOS|FxiOS|EdgiOS|OPiOS|mercury)/i.test(ua);
  return !inApp && !otherIosBrowser;
}
